/**
 * API service for Documents.
 * Endpoint: /api/documents/{loanId}
 */
import axios from "axios";

const API_DOMAIN = process.env.REACT_APP_TPOC_API_DOMAIN;

/**
 * Fetch documents (eFolders) for a loan.
 * GET /api/documents/{loanId}
 * @param {string} loanId - loan identifier (route param)
 * @param {string} token - access token for authorization
 * @returns {Promise<Array>} array of document/folder objects
 */
export const fetchDocuments = async (loanId, token) => {
  const response = await axios.get(`${API_DOMAIN}/api/documents/${loanId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data || [];
};

/**
 * Fetch attachment detail (on-demand) with download URL and page thumbnails.
 * GET /api/documents/{loanId}/attachments/{attachmentId}
 * @param {string} loanId - loan identifier
 * @param {string} attachmentId - attachment identifier
 * @param {string} token - access token for authorization
 * @returns {Promise<object>} attachment detail with pages array
 */
export const fetchAttachmentDetail = async (loanId, attachmentId, token) => {
  const response = await axios.get(
    `${API_DOMAIN}/api/documents/${loanId}/attachments/${attachmentId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};
